import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './MemberNavigation.module.css';

const MemberNavigation: React.FC = () => {
  const { member, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  const handleLogout = async () => {
    closeMenu();
    await logout();
  };

  return (
    <nav className={styles.nav}>
      <div className={styles.container}>
        <Link to="/members/dashboard" className={styles.logoLink} onClick={closeMenu}>
          <img
            src="/assets/images/logo.png"
            alt="B2B"
            className={styles.logo}
          />
        </Link>

        <div className={styles.links}>
          <Link
            to="/members/dashboard"
            className={`${styles.link} ${isActive('/members/dashboard') ? styles.active : ''}`}
          >
            Dashboard
          </Link>
          <Link
            to="/members/editions"
            className={`${styles.link} ${isActive('/members/editions') ? styles.active : ''}`}
          >
            Editions
          </Link>
          <Link
            to="/members/directory"
            className={`${styles.link} ${isActive('/members/directory') ? styles.active : ''}`}
          >
            Directory
          </Link>
        </div>

        <div className={styles.userSection}>
          {member && <span className={styles.userName}>{member.name}</span>}
          <button onClick={handleLogout} className={styles.logoutBtn}>
            Logout
          </button>
        </div>

        <button
          className={styles.hamburger}
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {menuOpen && (
        <div className={styles.mobileMenu}>
          <Link
            to="/members/dashboard"
            className={`${styles.mobileLink} ${isActive('/members/dashboard') ? styles.active : ''}`}
            onClick={closeMenu}
          >
            Dashboard
          </Link>
          <Link
            to="/members/editions"
            className={`${styles.mobileLink} ${isActive('/members/editions') ? styles.active : ''}`}
            onClick={closeMenu}
          >
            Editions
          </Link>
          <Link
            to="/members/directory"
            className={`${styles.mobileLink} ${isActive('/members/directory') ? styles.active : ''}`}
            onClick={closeMenu}
          >
            Directory
          </Link>
          <div className={styles.mobileDivider} />
          {member && <span className={styles.mobileUserName}>{member.name}</span>}
          <button onClick={handleLogout} className={styles.mobileLogout}>
            Logout
          </button>
        </div>
      )}
    </nav>
  );
};

export default MemberNavigation;
